import { InputHasErrorProp, InputSizeVariantProp, baseStyles } from './styles'
import { FC, InputHTMLAttributes } from 'react'
import styled from 'styled-components'

const StyledSelect = styled.select<InputHasErrorProp & InputSizeVariantProp>`
  ${baseStyles};
  padding-bottom: 0;
  background-size: 2rem;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  position: relative;
  background: url("data:image/svg+xml,%3Csvg width='8' height='5' viewBox='0 0 8 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0H0L4 5L8 0Z' fill='%23818181' /%3E%3C/svg%3E%0A")
    no-repeat 100% 55%;
  height: 2.5rem;
`

export interface SelectProps
  extends InputHasErrorProp,
    InputSizeVariantProp,
    InputHTMLAttributes<HTMLSelectElement> {}

export const Select: FC<SelectProps> = ({ variant = 'regular', ...rest }) => (
  <StyledSelect data-field-id={rest.name} variant={variant} {...rest} />
)
